import * as React from 'react';
import { Helmet } from './meta';
const WithTitle = ({ title, children }) => (React.createElement(React.Fragment, null,
    React.createElement(Helmet, null,
        React.createElement("title", null, title || '')),
    children));
WithTitle.displayName = 'WithTitle';
export default WithTitle;
//# sourceMappingURL=WithTitle.js.map